<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--refining form-wrap__title--sticky">Подтвердите условия микрокредита</h1>
                <div class="form-wrap__row">
                    <calculator v-bind="product" v-if="product"></calculator>
                </div>

                <div class="form-wrap__row">
                    <div class="form-button__wrap">
                        <router-link :to="{name: 'Purpose'}" tag="button" class="form-button form-button--violet">
                            Продолжить
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {createHelpers} from 'vuex-map-fields';
    import productAdapter from '@/modules/productAdapter';
    import Raven from 'raven-js'
    const {mapFields} = createHelpers({
        getterType: 'calculator/getField',
        mutationType: 'calculator/updateField',
    });

    export default {
        name: 'Refining',
        data() {
            return {
                product: ''
            }
        },
        methods: {},
        computed: {
            isProductEmpty: function () {
                return this.product === '';
            },
            ...mapFields([
                'amount',
                'amountExternalStatus',
                'amountExternalError',

                'term',
                'termExternalStatus',
                'termExternalError',

                'creditType',
                'creditTypeExternalStatus',
                'creditTypeExternalError',

                'productID'
            ]),
        },
        beforeCreate(){
            if( !this.$store.getters['profile/isInited'] ){
                this.$store.dispatch('profile/INIT');
            }
        },
        mounted() {
            this.$store.commit('CHANGE_PROGRESS', {progressBarShow: true, currentPercent: 70, nextPercent: 10});
            let _this = this;
            this.$http.get('/json/product').then(
                response => {
                    if (response.data.code === 0) {
                        let product = productAdapter.getActiveProduct(response.data.data.available, "MicroProductEngine");
                        this.$store.commit('calculator/updateField', {path: 'productID', value:product.id});
                        _this.product = productAdapter.transformProduct(product);
                        Raven.captureMessage('Step end: '+_this.$options.name, {
                            level: 'info'
                        });
                    }
                },
                response => {
                    console.log(response)

                }
            );
        }
    }
</script>

<style lang="scss">

</style>